import { Box } from "@mui/material"
import React, { useEffect } from "react"
import { useMediaQuery } from "react-responsive"
import { useNavigate } from "react-router"
import { useLoginContext } from "src/hooks/useLoginContext"
import { MEMBER_TYPE, MENU_TYPE } from "src/modules/const"
import { TopMenuItem } from "../TopMenuItem"
import { FavoriteVideoPageItem } from "./FavoriteVideoPageItem"

export const FavoriteVideoPage = () => {
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  const navigate = useNavigate()
  const { userType, initialized } = useLoginContext()

  useEffect(() => {
    if (!initialized) return
    if (userType != MEMBER_TYPE.USER && userType != MEMBER_TYPE.ADVISER) {
      navigate("/")
    }
  }, [initialized, userType])

  return (
    <>
      {isTablet ? (
        <></>
      ) : (
        <Box position="absolute" sx={{ width: "100%", height: "60px" }}>
          <Box display="flex">
            <TopMenuItem mainMenuIndex={MENU_TYPE.FAVORITE_VIDEO} />
          </Box>
        </Box>
      )}

      {isTablet ? (
        <Box className="page_box">
          <Box className="page_content">
            <FavoriteVideoPageItem />
          </Box>
        </Box>
      ) : (
        <Box display="block">
          <Box className="page_box_sp">
            <Box className="page_content_sp">
              <FavoriteVideoPageItem />
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}
